module.exports = __webpack_public_path__ + "static/media/menu.c0e3bc7b.svg";